/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Status_Failed_TitleInputs */

const en_course_status_failed_title = /** @type {(inputs: Course_Status_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not passed`)
};

const ja_course_status_failed_title = /** @type {(inputs: Course_Status_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不合格`)
};

const fr_course_status_failed_title = /** @type {(inputs: Course_Status_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non réussi`)
};

const de_course_status_failed_title = /** @type {(inputs: Course_Status_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht bestanden`)
};

/**
* | output |
* | --- |
* | "Not passed" |
*
* @param {Course_Status_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_status_failed_title = /** @type {((inputs?: Course_Status_Failed_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Status_Failed_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_status_failed_title(inputs)
	if (locale === "ja") return ja_course_status_failed_title(inputs)
	if (locale === "fr") return fr_course_status_failed_title(inputs)
	return de_course_status_failed_title(inputs)
});